import optimizelySDK from '@optimizely/optimizely-sdk';

optimizelySDK.setLogLevel('warning');

const optimizelyClientInstance = optimizelySDK.createInstance({
  datafile: (window as any).optimizelyDatafile,
});

export default optimizelyClientInstance;
